import React from 'react';
import { CheckCircle } from '@phosphor-icons/react';

/**
 * Estado de cierre de jornada cuando el tecnico ya no tiene tareas activas.
 */
function CompletedDayCard({
    technicianName = '',
    completedTasksCount = 0,
    cancelledTasksCount = 0,
    totalTasksCount = 0
}) {
    const normalizeTechnicianName = (name) => {
        const trimmedName = String(name || '').trim();
        if (!trimmedName) {
            return 'tecnico';
        }

        // Corrige casos de mojibake comunes como "TÃ©cnico".
        if (/[ÃÂâ]/.test(trimmedName)) {
            try {
                const bytes = Uint8Array.from(trimmedName, (char) => char.charCodeAt(0));
                const decodedName = new TextDecoder('utf-8').decode(bytes);
                if (decodedName && !decodedName.includes('�')) {
                    return decodedName;
                }
            } catch {
                // Si falla la normalización, conservar el valor original.
            }
        }

        return trimmedName;
    };

    const safeTechnicianName = normalizeTechnicianName(technicianName);

    return (
        <div className="rounded-2xl border border-success/40 bg-surface p-6 text-center shadow-md sm:p-8 lg:p-10">
            <div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-success/12 ring-1 ring-success/30">
                <CheckCircle size={42} weight="fill" className="text-success" />
            </div>

            <p className="text-sm font-semibold uppercase tracking-[0.24em] text-success">
                Eres el número 1
            </p>

            <h3 className="mt-3 text-3xl font-semibold text-content sm:text-4xl">
                Has finalizado todas las tareas
            </h3>

            <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-content-muted sm:text-lg">
                Has completado exitosamente todas las tareas asignadas para hoy. Buen trabajo, {safeTechnicianName}.
            </p>

            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3">
                <div className="rounded-xl border border-line bg-surface-2/70 px-4 py-5">
                    <div className="text-3xl font-bold text-content">{completedTasksCount}</div>
                    <div className="mt-1 text-sm text-content-muted">Completadas</div>
                </div>

                <div className="rounded-xl border border-line bg-surface-2/70 px-4 py-5">
                    <div className="text-3xl font-bold text-content">{cancelledTasksCount}</div>
                    <div className="mt-1 text-sm text-content-muted">Canceladas</div>
                </div>

                <div className="rounded-xl border border-line bg-surface-2/70 px-4 py-5">
                    <div className="text-3xl font-bold text-content">{totalTasksCount}</div>
                    <div className="mt-1 text-sm text-content-muted">Asignadas hoy</div>
                </div>
            </div>
        </div>
    );
}

export default CompletedDayCard;
